"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isContentLoopToken = exports.createContentLoopBody = exports.createContentLoopDummy = exports.createDefaultContentLoopChildren = exports.contentLoop = void 0;
var Common_1 = require("ContentTokens/Models/Common");
var BasicBlocks_1 = require("./BasicBlocks");
var Text_1 = require("./Text");
var contentLoop = {
    createToken: function (content, variable) {
        if (content === void 0) { content = []; }
        var token = {
            type: "block",
            subType: "contentLoop",
            content: content,
        };
        if (variable) {
            token.variable = variable;
        }
        return token;
    },
    createSlateJson: function (children, variable) {
        var node = {
            type: Common_1.BlockType.ContentLoop,
            data: {},
            children: [createContentLoopDummy(), createContentLoopBody(children)],
            isVoid: false,
        };
        if (variable) {
            node.data.variable = variable;
        }
        return node;
    },
};
exports.contentLoop = contentLoop;
var createDefaultContentLoopChildren = function () {
    return [BasicBlocks_1.paragraph.createSlateJson([Text_1.text.createSlateJson("")])];
};
exports.createDefaultContentLoopChildren = createDefaultContentLoopChildren;
var createContentLoopBody = function (children) {
    if (children === void 0) { children = createDefaultContentLoopChildren(); }
    return {
        isVoid: false,
        type: Common_1.BlockType.ContentLoopBody,
        children: children,
    };
};
exports.createContentLoopBody = createContentLoopBody;
var createContentLoopDummy = function () {
    return {
        isVoid: true,
        type: Common_1.BlockType.ContentLoopDummy,
        children: [Text_1.text.createSlateJson("")],
    };
};
exports.createContentLoopDummy = createContentLoopDummy;
var isContentLoopToken = function (token) {
    return token.type === "block" && token.subType === "contentLoop";
};
exports.isContentLoopToken = isContentLoopToken;
